import { useNavigate, useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getProductionPresetDetails, updateProductionPreset } from "../../helpers/http_production_presets_requests";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export default function ProductionPresetUpdate() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { id } = useParams();

    const { data, isFetching } = useQuery({
        queryKey: ["getProductionPresetDetails", id],
        queryFn: () => getProductionPresetDetails(id),
        staleTime: 1000 * 5,
    });

    const { data: presetData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Preset - Editar",
            fields: [
                { name: "name", label: "Nome", type: "text", required: true },
                { name: "position", label: "Ordem", type: "number", required: true },
                { name: "prod_steps_json", label: "Passos de Produção", type: "steps", fullWidth: true },
                { name: "is_active", label: "Ativo", type: "switch" },
            ],
        },
    ];

    const handleSubmit = (formData) => {
        updateProductionPreset(
            {
                id: Number(id),
                name: formData.name,
                position: Number(formData.position) || 0,
                prod_steps_json: formData.prod_steps_json || [],
                is_active: Boolean(formData.is_active),
            },
            () => {
                queryClient.invalidateQueries({ queryKey: ["getProductionPresets"] });
                navigate("/configuracao-presets");
            }
        );
    };

    return (
        <DynamicFormPage
            isLoading={isFetching}
            initialData={presetData}
            title="Preset - Editar"
            formFieldList={formFieldList}
            onCancel={() => navigate(-1)}
            onSubmit={handleSubmit}
        />
    );
}
